import { ISearchItem } from "MVVM/Components/SearchBar/NavSearchBar";

const RECENT_SEARCHES_KEY = "recentSearches";
const MAX_RECENT_SEARCHES = 5;

export const getRecentSearches = (): ISearchItem[] => {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    if (!stored) {
      return [];
    }
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Error reading recent searches from localStorage:", error);
    return [];
  }
};

export const addRecentSearch = (item: ISearchItem): void => {
  if (!item?.id) {
    return;
  }

  try {
    const withoutDupe = getRecentSearches().filter((r) => r.id !== item.id);
    const next = [item, ...withoutDupe].slice(0, MAX_RECENT_SEARCHES);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next));
  } catch (error) {
    console.error("Error adding recent search to localStorage:", error);
  }
};
